import { EmailTemplateButton } from './EmailTemplateButton'

const PreeventRemind = function () {
  return <div style={{ marginBottom: 20 }}>
    <EmailTemplateButton
      type='Pre-session'
      title='Registration Remind Email Template'
      settingKey='pre-session.registration.remind'
      showSendButton />
  </div>
}

export default PreeventRemind
